interface reCAPTCHARenderOptions {
  sitekey: string;
  callback: () => void;
  size?: string;
  "expired-callback"?: () => void;
  "error-callback"?: () => void;
}

declare global {
  interface Window {
    grecaptcha?: {
      ready?: (cb: () => void) => void;
      render?: (id: string, options: reCAPTCHARenderOptions) => void;
      getResponse?: () => string;
      execute?: () => void;
      reset?: () => void;
    };
    ___grecaptcha_cfg: {
      fns: (() => void)[];
    };
    __recaptcha_api: string;
    grecaptchaCloseListener?: boolean;
  }
}

export const prepReCAPTCHA = () => {
  if (!window.grecaptcha) {
    window.grecaptcha = {};
  }
  if (!window.grecaptcha.ready) {
    window.grecaptcha.ready = (cb: () => void) => {
      if (!window.grecaptcha?.render && !window.grecaptcha?.execute) {
        const c = "___grecaptcha_cfg";
        window[c] = window[c] || {};
        (window[c]["fns"] = window[c]["fns"] || []).push(cb);
      } else {
        cb();
      }
    };
  }
};

const reCAPTCHAResponse = (tokenCB: (token: string) => void) => () => {
  const token =
    window.grecaptcha && window.grecaptcha.getResponse
      ? window.grecaptcha.getResponse()
      : "";

  if (window.grecaptcha && window.grecaptcha.reset) {
    window.grecaptcha.reset();
  }
  tokenCB(token);
};

export const renderReCAPTCHA = (
  containerId: string,
  key: string,
  responseCallback: (token: string) => void,
  issueCallback: () => void
) => {
  if (window.grecaptcha && window.grecaptcha.ready) {
    window.grecaptcha.ready(() => {
      if (window.grecaptcha && window.grecaptcha.render) {
        window.grecaptcha.render(containerId, {
          sitekey: key,
          callback: reCAPTCHAResponse(responseCallback),
          size: "invisible",
          "expired-callback": issueCallback,
          "error-callback": issueCallback,
        });
      }
    });
  }
};

export const submitReCAPTCHA = () => {
  if (window.grecaptcha && window.grecaptcha.ready) {
    window.grecaptcha.ready(() => {
      if (window.grecaptcha && window.grecaptcha.execute) {
        window.grecaptcha.execute();
      }
    });
  }
};
